
import { mapState, mapGetters } from 'vuex';
import SocialMediaType from '@/enums/SocialMediaType';
import MediaSummaryStyle from '@/enums/MediaSummaryStyle';

export default {
  name: 'AppHeaderV2MediaSummarySection',
  computed: {
    ...mapState('widget', ['widget']),
    ...mapState('review', ['totalProductMediaReviewsCount']),
    ...mapState('window', ['windowService']),
    ...mapState('productMediaReviewSummary', ['isLoadingMediaReviewSummary']),
    ...mapGetters('widget', [
      'allMediaReviewsPopupUrl',
      'mediaReviewPopupUrlByReviewPopupStyle'
    ]),
    ...mapGetters('productMediaReviewSummary', ['reviewMedia']),
    SocialMediaType: () => SocialMediaType,
    isMediaSummaryStyleVertical() {
      return this.widget.media_summary_style === MediaSummaryStyle.VERTICAL;
    },
    mediaSummaryShape() {
      return this.isMediaSummaryStyleVertical ? 'vertical' : 'square';
    }
  },
  methods: {
    clickShowAll(event) {
      if (event.metaKey || event.ctrlKey) return;

      event.preventDefault();
      this.windowService.openFullscreenPopup(
        this.allMediaReviewsPopupUrl,
        event.currentTarget
      );
    },
    clickShowMediaReviewPopup(event, review_id, media_position, review_index) {
      if (event.metaKey || event.ctrlKey) return;

      event.preventDefault();
      this.windowService.openFullscreenPopup(
        this.mediaReviewPopupUrlByReviewPopupStyle(
          review_id,
          media_position,
          review_index
        ),
        event.currentTarget
      );
    }
  }
};
